import React from 'react';
import { useTranslation } from 'react-i18next';
import { HeaderCell, HeaderRow, Table, Wrapper } from './EffectDropdownTable.styles';
import EffectDropdownTableRow from './EffectDropdownTableRow/EffectDropdownTableRow';
import { defaultScales } from '../../../../../../../helpers/helpers';
import { IToggleState, Question } from '../../../../../../../services/reports';

interface EffectDropdownTableProps {
  questions: Question[];
  togglersState: IToggleState;
}

const EffectDropdownTable: React.FC<EffectDropdownTableProps> = ({ questions, togglersState }) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Table>
        <thead>
          <HeaderRow>
            <HeaderCell>{t('report.effect.table.question')}</HeaderCell>
            <HeaderCell>{t('report.effect.table.score')}</HeaderCell>
            <HeaderCell></HeaderCell>
            <HeaderCell>
              {defaultScales.map(item => (
                <div key={item}>{item}</div>
              ))}
            </HeaderCell>
            <HeaderCell>?</HeaderCell>
          </HeaderRow>
        </thead>
        <tbody>
          {questions.map(item => (
            <EffectDropdownTableRow key={item.text} data={item} togglersState={togglersState} />
          ))}
        </tbody>
      </Table>
    </Wrapper>
  );
};

export default EffectDropdownTable;
